/* tslint:disable */
/* eslint-disable */
/**
 * Speechmatics ASR REST API
 * The Speechmatics Automatic Speech Recognition REST API is used to submit ASR jobs and receive the results. The supported job type is transcription of audio files.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@speechmatics.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Configuration options for summarization.
 * @export
 * @interface SummarizationConfig
 */
export interface SummarizationConfig {
  /**
   * Choose from three options: - `conversational` - Best suited for dialogues involving multiple participants, such as calls, meetings or discussions. It focuses on summarizing key points of the conversation. - `informative` - Recommended for more structured information delivered by one or more people, making it ideal for videos, podcasts, lectures, and presentations. - `auto` - Automatically selects the most appropriate content type based on an analysis of the transcript.
   * @type {string}
   * @memberof SummarizationConfig
   */
  content_type?: SummarizationConfigContentTypeEnum;
  /**
   * Determines the depth of the summary: - `brief` - Provides a succinct summary, condensing the content into just a few sentences. - `detailed` - Provide a longer, structured summary. For _conversational_ content, it includes key topics and a summary of the entire conversation. For _informative_ content, it logically divides the audio into sections and provides a summary for each.
   * @type {string}
   * @memberof SummarizationConfig
   */
  summary_length?: SummarizationConfigSummaryLengthEnum;
  /**
   *
   * @type {string}
   * @memberof SummarizationConfig
   */
  summary_type?: SummarizationConfigSummaryTypeEnum;
}

export const SummarizationConfigContentTypeEnum = {
  Auto: 'auto',
  Informative: 'informative',
  Conversational: 'conversational',
} as const;

export type SummarizationConfigContentTypeEnum =
  (typeof SummarizationConfigContentTypeEnum)[keyof typeof SummarizationConfigContentTypeEnum];
export const SummarizationConfigSummaryLengthEnum = {
  Brief: 'brief',
  Detailed: 'detailed',
} as const;

export type SummarizationConfigSummaryLengthEnum =
  (typeof SummarizationConfigSummaryLengthEnum)[keyof typeof SummarizationConfigSummaryLengthEnum];
export const SummarizationConfigSummaryTypeEnum = {
  Paragraphs: 'paragraphs',
  Bullets: 'bullets',
} as const;

export type SummarizationConfigSummaryTypeEnum =
  (typeof SummarizationConfigSummaryTypeEnum)[keyof typeof SummarizationConfigSummaryTypeEnum];
